import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getRequest, postRequest } from "../../globalhelper/helper";
import SaveIcon from "@mui/icons-material/Save";

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Alert,
    AlertTitle,
    Box,
    Button,
    Typography,
    Grid,
    TextField,
    Autocomplete,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Tooltip,
    Select,
    MenuItem,
    IconButton
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { styled } from "@mui/material/styles";
import { toast } from "react-toastify";
import download from 'downloadjs';
import axios from 'axios';
import ApiConstants from "../../config.json";
import { error } from "jquery";

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});

const DocumentTypes = ["Supplier Bill", "Transporter Bill"];
const Vendors = [
    { VendorName: "M&C SAATCHI MOBILE INDIA LLP", VendorID: "VM0000000030" },
];

const TransactionLog = () => {
    const history = useHistory();
    const [Companies, setCompanies] = useState([]);
    const [allTableData, setAllTableData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [originalTableData, setOriginalTableData] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [editingRow, setEditingRow] = useState(null);
    const [formData, setFormData] = useState({
        company: null
    });

    const [TransactionType, setTransactionType] = useState("");
    const [TransactionTypes, setTransactionTypes] = useState([]);
    const [ThemeName, setThemeName] = useState("");
    const [ThemeNames, setThemeNames] = useState([]);
    const [From, setFrom] = useState(() => moment().startOf("month").format("YYYY-MM-DD"));
    const [To, setTo] = useState(() => moment().endOf("month").format("YYYY-MM-DD"));
    const [GSTIN, setGSTIN] = useState("");
    const [GSTINs, setGSTINs] = useState([]);
    const [DocumentType, setDocumentType] = useState("");
    const [vendor, setVendor] = useState({});
    const [FNSError, setFNSError] = useState("");
    const [processCode, setProcessCode] = useState("");

    const [dropdownData, setDropdownData] = useState({
        transactionTypes: [],
        processCodes: [],
        themeMappings: []
    });



    useEffect(() => {

    if (!formData.company?.orgid) return;

    postRequest("api/edureka/getDataIngestionMappings", {
        orgid: formData.company.orgid
    })
    .then((response) => {

        const result = response.res?.data || {};

        setTransactionTypes(result.transactionTypes || []);

    })
    .catch(console.error);

}, [formData.company]);


    useEffect(() => {

        getRequest("api/edureka/getCompanyAssignedToUser")
            .then(({ res }) => {
                setCompanies(res.data || []);
            });

        postRequest("api/edureka/getTransactionLogTable", {
            system: localStorage.getItem("system"),
            orgid: localStorage.getItem("system") // or whatever backend expects initially
        })
            .then((result) => {
                const parsed = JSON.parse(result.res.data || result.data);
                const data = Array.isArray(parsed) ? parsed : [parsed];

                setAllTableData(data);
                //setTableData(data);
setOriginalTableData(JSON.parse(JSON.stringify(data)));
            });

    }, []);

useEffect(() => {
  getRequest("api/edureka/getTransactionDropdowns")
    .then(({ res }) => {
      setDropdownData(res.data);
    })
    .catch(console.error);
}, []);


    const downloadFile = (s3Key) => {
        let obj = {
            key: s3Key,
            tenant_id: localStorage.getItem('tenant_id') || localStorage.getItem('system')
        };
        axios.post(ApiConstants.externals.serverUrl + 'api/transactions/downloadS3FileWithKey', obj, { responseType: 'blob' })
            .then(result => {
                if (result && result.data) {
                    const blob = result.data;
                    const fileName = s3Key.split('/').pop() || 'downloaded_file.csv';
                    download(blob, fileName);
                } else {
                    toast.error("No such file found.");
                }
            })
            .catch((error) => {
                console.error(error);
                toast.error("Failed to download file.");
            });
    };

    // const handleRowChange = (rowIndex, colName, value) => {
    //     const newData = [...tableData];
    //     newData[rowIndex][colName] = value;
    //     setTableData(newData);
    // };

    const handleRowChange = (
    rowIndex,
    column,
    value
) => {

    const temp = [...tableData];

    temp[rowIndex][column] = value;

    if (column === "processcode") {
        temp[rowIndex].themename = "";
    }

    setTableData(temp);

};

const saveTransaction = async (rowIndex) => {
    try {

        const row = tableData[rowIndex];
        const oldRow = originalTableData[rowIndex];

        const payload = {
            TransactionID: row.transactionid,
            OrgID: row.orgid,

            OldChanges: {
                ProcessCode: oldRow.processcode,
                ThemeName: oldRow.themename,
                TransactionType: oldRow.transactiontype
            },

            NewChanges: {
                ProcessCode: row.processcode,
                ThemeName: row.themename,
                TransactionType: row.transactiontype
            }
        };

        console.log("Payload");
        console.log(payload);

        const { res } = await postRequest(
            "api/edureka/updateTransactionLog",
            payload
        );

        if (res.code === 200) {

            toast.success("Updated Successfully");

            const result = await postRequest(
                "api/edureka/getTransactionLogTable",
                {
                    system: localStorage.getItem("system"),
                    orgid: localStorage.getItem("system")
                }
            );

            const parsed = JSON.parse(result.res.data || result.data);
            const data = Array.isArray(parsed) ? parsed : [parsed];

            setAllTableData(data);
            setTableData(data);
            setOriginalTableData(JSON.parse(JSON.stringify(data)));

        }

    } catch (err) {
        console.error(err);
        toast.error("Update Failed");
    }
};

    const displayColumns = [
        "transactionid",
        "transactiontype",
        "processcode",
        "themename",
        "status",
        // "errormessage",
        "createdat",
        // "metadatacount",
        // "mappedcount",
        // "unmappedcount",
        "datakey",
        "error",
        "actions"
    ]

    const handleChange = (name, value) => {
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

const handleSubmit = async () => {

    if (!formData.company) {
        toast.warning("Please select Company");
        return;
    }

    if (selectedFiles.length === 0) {
        toast.warning("Please select a file");
        return;
    }

    try {

        const formDataUpload = new FormData();

        formDataUpload.append("file", selectedFiles[0]);

        formDataUpload.append("TransactionType", TransactionType || "");

        formDataUpload.append("ThemeName", ThemeName || "");

        formDataUpload.append("ProcessCode", processCode || "");

        const response = await postRequest(
            `api/upload/uploadTransactionLog?OrgID=${formData.company.orgid}`,
            formDataUpload
        );

        if (response?.type === "success" || response?.status === 200) {
            toast.success("Upload Successful");
            setSelectedFiles([]);
        } else {
            toast.error("Upload Failed");
        }

    } catch (err) {
        console.error(err);
        toast.error("Upload Failed");
    }
};

    const handleCompanyChange = (val) => {

        handleChange("company", val);

        setTransactionType("");
        setThemeName("");
        setThemeNames([]);
        setTransactionTypes([]);
        setProcessCode("");

        if (val) {
            setTableData(allTableData);
        } else {
            setTableData([]);
        }
    };

const handleTransactionTypeChange = (val) => {

    setTransactionType(val);
    setThemeName("");
    setThemeNames([]);
    setProcessCode("");

    if (!val) return;

    postRequest("api/edureka/getDataIngestionMappings", {
        orgid: formData.company.orgid,
        transactionType: val
    })
    .then((response) => {

        const result = response.res?.data || {};

        setThemeNames(result.themeNames || []);
        setProcessCode(result.processCode || "");

    })
    .catch(console.error);
};

    const downloadCSV = () => {
        if (!formData.company || !TransactionType || !ThemeName) {
            toast.warning("All dropdowns must be selected before downloading the file.");
            return;
        }

        postRequest(
            `api/upload/getcsv?OrgID=${formData.company?.orgid || ""}&TransactionType=${TransactionType}&ThemeName=${ThemeName}`,
            {
                responseType: "json",
            }
        )
            .then((res) => {
                if (
                    res?.res?.data?.type === "Buffer" &&
                    Array.isArray(res.res.data.data)
                ) {
                    const byteArray = new Uint8Array(res.res.data.data);

                    const contentType =
                        res?.res?.headers?.["content-type"] || "application/octet-stream";

                    const fileExtensionMap = {
                        "text/csv": ".csv",
                        "application/pdf": ".pdf",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                            ".xlsx",
                        "application/zip": ".zip",
                    };

                    const extension = fileExtensionMap[contentType] || ".csv";

                    const blob = new Blob([byteArray], { type: contentType });
                    const url = window.URL.createObjectURL(blob);

                    const link = document.createElement("a");
                    link.href = url;
                    link.download = `${ThemeName}${extension}`;
                    document.body.appendChild(link);
                    link.click();

                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                } else {
                    console.error("Invalid file data structure:", res.res?.data || res.data);
                    toast.error("Invalid file data structure.");
                }
            })
            .catch((err) => {
                console.error("Error downloading file:", err);
                toast.error("Error downloading file.");
            });
    };

const fileInputOnChange = (e) => {

    const file = e.target.files[0];

    if (!file) return;

    setSelectedFiles([file]);

    const { MAX_TOTAL_SIZE } = ApiConstants.externals;

    if (file.size > Number(MAX_TOTAL_SIZE)) {

        setFNSError(
            `The total size of all files must not exceed 50 MB. Currently: ${(
                file.size / (1024 * 1024)
            ).toFixed(2)} MB`
        );

        return;
    }

    setFNSError("");

    e.target.value = null;
};

    const handleDeleteFile = (index) => {

        const updatedFiles =
            selectedFiles.filter((_, i) => i !== index);

        setSelectedFiles(updatedFiles);

    };

    const handleReset = () => {
        setFormData({
            company: null
        });
        setTableData([]);
        setTransactionType("");
        setTransactionTypes([]);
        setThemeName("");
        setThemeNames([]);
        setGSTIN("");
        setGSTINs([]);
        setDocumentType("");
        setVendor({});
        setFNSError("");
        setSelectedFiles([]);
        const currentDate = moment();
        setFrom(moment(currentDate).startOf("month").format("YYYY-MM-DD"));
        setTo(moment(currentDate).endOf("month").format("YYYY-MM-DD"));
    };

    return (
        <>
            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">Transaction Log</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                size="small"
                                value={formData.company}
                                options={Companies}
                                getOptionLabel={(option) => option?.orgname || ""}
                                onChange={(e, value) => handleCompanyChange(value)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Company" />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                size="small"
                                fullWidth
                                value={TransactionType || null}
                                options={TransactionTypes}
                                getOptionLabel={(option) => option}
                                onChange={(event, newValue) => handleTransactionTypeChange(newValue)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="TransactionType"
                                        variant="outlined"
                                        name="TransactionType"
                                    />
                                )}
                            />
                        </Grid>

                        {(!TransactionType || TransactionType !== "BILL") && (
                            <Grid item xs={12} md={3}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    value={ThemeName || null}
                                    options={ThemeNames}
                                    getOptionLabel={(option) => option}
                                    onChange={(event, newValue) => setThemeName(newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Theme Name"
                                            variant="outlined"
                                            name="ThemeName"
                                        />
                                    )}
                                />
                            </Grid>
                        )}

                        {formData.company && TransactionType && ThemeName && (
                            <Grid item xs={12} md={2}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={downloadCSV}
                                    fullWidth
                                >
                                    Download Theme
                                </Button>
                            </Grid>
                        )}
                    </Grid>

                    <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>


                        {TransactionType === "InstructorInvoice" ? (
                            <Grid item xs={12} md={3}>
                                <Autocomplete
                                    size="small"
                                    fullWidth
                                    value={GSTIN || null}
                                    options={GSTINs}
                                    getOptionLabel={(option) => option}
                                    onChange={(event, newValue) => setGSTIN(newValue)}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="GSTIN"
                                            variant="outlined"
                                            name="GSTIN"
                                        />
                                    )}
                                />
                            </Grid>
                        ) : TransactionType === "InstructorCostAccrual" ||
                            !TransactionType ? null : TransactionType === "BILL" ? (
                                <Grid item xs={12} md={3}>
                                    <Autocomplete
                                        size="small"
                                        fullWidth
                                        value={DocumentType || null}
                                        options={DocumentTypes}
                                        getOptionLabel={(option) => option}
                                        onChange={(event, newValue) => setDocumentType(newValue)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Doc Type"
                                                variant="outlined"
                                                name="DocType"
                                            />
                                        )}
                                    />
                                </Grid>
                            ) : (
                            <>

                            </>
                        )}


                        {formData.company?.orgid && (
                            <Grid item xs={12} md={3}>

                                <Button
                                    disabled={!formData.company}
                                    component="label"
                                    variant="contained"
                                    startIcon={<CloudUploadIcon />}
                                    fullWidth
                                >
                                    Upload file

                                    <VisuallyHiddenInput
                                        multiple
                                        type="file"
                                        onChange={fileInputOnChange}
                                    />

                                </Button>

                                {/* FILE LIST DISPLAY */}

                                {selectedFiles.length > 0 && (

                                    <Box sx={{ mt: 2 }}>

                                        {selectedFiles.map((file, index) => (

                                            <Box
                                                key={index}
                                                display="flex"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                sx={{
                                                    border: "1px solid #ccc",
                                                    padding: "8px",
                                                    marginBottom: "5px"
                                                }}
                                            >

                                                <Typography>
                                                    {file.name}
                                                </Typography>

                                                <Button
                                                    color="error"
                                                    size="small"
                                                    onClick={() => handleDeleteFile(index)}
                                                >
                                                    Delete
                                                </Button>

                                            </Box>

                                        ))}

                                    </Box>

                                )}

                                <small
                                    style={{
                                        color: "red",
                                        display: "block",
                                        marginTop: "4px"
                                    }}
                                >
                                    {FNSError}
                                </small>

                            </Grid>
                        )}



                    </Grid>

                    <Grid container spacing={2} alignItems="center" sx={{ mt: 2 }}>
                        <Grid item>
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={handleSubmit}
                                disabled={!formData.company}
                            >
                                Submit
                            </Button>
                            <Button
                                color="error"
                                variant="contained"
                                sx={{ ml: 1 }}
                                onClick={handleReset}
                            >
                                Reset
                            </Button>
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {tableData.length > 0 ? (
                <Box sx={{ mt: 2 }}>
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableHead>
                                <TableRow sx={{ backgroundColor: 'rgba(0, 61, 155, 0.05)' }}>
                                    {displayColumns.map((colName, index) => (
                                        <TableCell key={index} sx={{ fontWeight: 700, color: '#003d9b', textTransform: 'capitalize', minWidth: colName === 'transactiontype' ? 250 : 'auto' }}>
                                            {colName}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.map((row, rowIndex) => (
                                    <TableRow key={rowIndex} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                        {displayColumns.map((colName, valIndex) => {
                                            const val = row[colName];
                                            let displayVal = val;
                                            if (colName === "transactiontype") {

    return (
        <TableCell key={valIndex} sx={{ minWidth: 250 }}>

            <Select
                size="small"
                fullWidth
                value={val || ""}
                disabled={row.status === "In Progress"}
                onChange={(e) =>
                    handleRowChange(
                        rowIndex,
                        "transactiontype",
                        e.target.value
                    )
                }
            >
                {TransactionTypes.map(item => (
                    <MenuItem
                        key={item}
                        value={item}
                    >
                        {item}
                    </MenuItem>
                ))}
            </Select>

        </TableCell>
    );
}


if (colName === "processcode") {

    return (
<TableCell
    key={valIndex}
    sx={{ minWidth: 220 }}
>
    <Box
        display="flex"
        alignItems="center"
        gap={1.5}
    >
        <Select
            fullWidth
            size="small"
            value={row.processcode || ""}
            onChange={(e) =>
                handleRowChange(
                    rowIndex,
                    "processcode",
                    e.target.value
                )
            }
        >
            {dropdownData.processCodes?.map(item => (
                <MenuItem
                    key={item.process_cd}
                    value={item.process_cd}
                >
                    {item.process_cd}
                </MenuItem>
            ))}
        </Select>

        <IconButton
            size="small"
            onClick={() =>
                history.push({
                    pathname: "/process",
                    state: {
                        selectedProcessCode: val
                    }
                })
            }
        >
            <EditIcon color="primary" fontSize="small" />
        </IconButton>
    </Box>
</TableCell>
    );
}


if (colName === "themename") {

    return (
<TableCell
    key={valIndex}
    sx={{ minWidth: 250 }}
>
    <Box
        display="flex"
        alignItems="center"
        gap={1.5}
    >
        <Select
            fullWidth
            size="small"
            value={row.themename || ""}
            onChange={(e) =>
                handleRowChange(
                    rowIndex,
                    "themename",
                    e.target.value
                )
            }
        >
            {(dropdownData.themeMappings || [])
                .filter(
                    item =>
                        item.processcode === row.processcode
                )
                .map(item => (
                    <MenuItem
                        key={item.themename}
                        value={item.themename}
                    >
                        {item.themename}
                    </MenuItem>
                ))}
        </Select>

        <IconButton
            size="small"
            onClick={() =>
                history.push({
                    pathname: "/theme-list",
                    state: {
                        selectedProcessCd: row.processcode,
                        selectedThemeName: val
                    }
                })
            }
        >
            <EditIcon color="primary" fontSize="small" />
        </IconButton>
    </Box>
</TableCell>
    );
}

                                            if (typeof val === 'number' && !Number.isInteger(val)) {
                                                displayVal = val.toFixed(2);
                                            } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                                                displayVal = parseFloat(val).toFixed(2);
                                            } else if (typeof val === 'boolean') {
                                                displayVal = val ? 'Yes' : 'No';
                                            } else if (val === null || val === undefined) {
                                                displayVal = '';
                                            } else if (typeof val === 'object') {
                                                displayVal = JSON.stringify(val);
                                            }



                                            if (colName === 'datakey' && val) {
                                                return (
                                                    <TableCell key={valIndex} sx={{ color: '#181c1e', textAlign: 'center' }}>
                                                        <Tooltip title={val}>
                                                            <Button
                                                                style={{ maxWidth: "100%", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}
                                                                variant="text"
                                                                size="small"
                                                                onClick={(e) => { e.preventDefault(); downloadFile(val); }}
                                                            >
                                                                <AttachFileIcon color="primary" />
                                                            </Button>
                                                        </Tooltip>
                                                    </TableCell>
                                                );
                                            }

                                            if (colName === "error") {

    const errorKey = `pretransaction_response/${row.orgid}/${row.transactionid}.xlsx`;

    return (
        <TableCell
            key={valIndex}
            sx={{
                color: "#181c1e",
                textAlign: "center"
            }}
        >
            <Tooltip title={errorKey}>
                <Button
                    variant="text"
                    size="small"
                    onClick={(e) => {
                        e.preventDefault();
                        downloadFile(errorKey);
                    }}
                >
                    <AttachFileIcon color="error" />
                </Button>
            </Tooltip>
        </TableCell>
    );
}

                                     if (colName === "actions") {

    return (

        <TableCell
            key={valIndex}
            align="center"
        >

            {row.status !== "In Progress" && (

                <IconButton
                    color="primary"
                   onClick={() => saveTransaction(rowIndex)}
                >
                    <SaveIcon/>
                </IconButton>

            )}

        </TableCell>

    );
}

                                            return (
                                                <TableCell key={valIndex} sx={{ color: '#181c1e' }}>
                                                    {String(displayVal)}
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            ) : (
                <Box sx={{ mt: 2 }}>
                    <Alert severity="info">
                        <AlertTitle>Info</AlertTitle>
                        Submit to fetch data.
                    </Alert>
                </Box>
            )}
        </>
    );
};

export default TransactionLog;